<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Configuración de impresion de comprobantes
    </h2>
    <MainConfigureVouchersPrint />
  </div>
</template>

<script>
import MainConfigureVouchersPrint from "@/components/ConfigurationModules/ConfigureVouchersPrint/MainConfigureVouchersPrint.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ConfigureVouchersPrint",
  components: {
    MainConfigureVouchersPrint,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
